export const TABLE_COLUMN_WIDTHS = {
    INDEX: 60,
    CHECKBOX: 35,
    STATUS: 90,
    RULE_NAME: 130,
    EMAIL: 260,
    VENDOR_NAME: 130,
    PREFERRED_EMAIL: 260,
    PARTNER_EMAIL: 260,
    LOCATION: 175,
    REASON: 240,
    FIRST_NAME: 180,
    LAST_NAME: 180,
    REQUEST_DATES: 160,
    ACTION: 100,
    RESOLVED_BY: 150,
    RESOLVED_DATE: 160,
};

export const MAX_INPUT_LENGTH = 100;
export const MIN_NAME_LEN = 2;

export const COLUMNS = {
    ROW_NUMBER: 'rowNumber',
    STATUS: 'status',
    EMAIL: 'email',
    PREFERRED_EMAIL: 'preferredEmail',
    PARTNER_EMAIL: 'partnerEmail',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    VENDOR_NAME: 'vendorName',
    RULE: 'rule',
    REASON: 'reason',
    REQUEST_DATE: 'requestDate',
    LOCATION: 'location',
    ACTION: 'action',
    APPROVED_BY: 'approvedBy',
    APPROVE_DATE: 'approveDate',
    DENIED_BY: 'deniedBy',
    DENIED_DATE: 'deniedDate',
} as const;

export const COLUMN_LABELS: Record<string, string> = {
    [COLUMNS.ROW_NUMBER]: '#',
    [COLUMNS.STATUS]: 'Status',
    [COLUMNS.EMAIL]: 'Email',
    [COLUMNS.PREFERRED_EMAIL]: 'Preferred Email',
    [COLUMNS.PARTNER_EMAIL]: 'Partner Email',
    [COLUMNS.VENDOR_NAME]: 'Vendor Name',
    [COLUMNS.RULE]: 'Rule',
    [COLUMNS.REASON]: 'Reason',
    [COLUMNS.LOCATION]: 'Location',
    [COLUMNS.ACTION]: 'Action',
    [COLUMNS.APPROVED_BY]: 'Approved by',
    [COLUMNS.APPROVE_DATE]: 'Approve Date',
    [COLUMNS.DENIED_BY]: 'Denied by',
    [COLUMNS.DENIED_DATE]: 'Denied Date',
};
